import { FormSearchUser } from '@/components/forms';
import { ISearchUserData } from '@/lib/interface';
import { broadcastService } from '@/services';
import { ReactNode } from 'react';

type TParams = {
  callback: (user: ISearchUserData) => Promise<void>;
  submitButtonTitle?: string;
  description?: ReactNode;
  title?: string;
};

const useFormSearchUser = () => {

  const search = (params: TParams) =>
    broadcastService
      .modal
      .show({
        content: <FormSearchUser {...params} />,
        width: 'md'
      });

  return ({
    search
  });

};

export default useFormSearchUser;
